import { logger } from '@lusha/client-logger';

import { ADDABLE_KEYS } from '../EditContact/consts';
import { getEditedContactData } from '../utils';

export function getContactAddedData({
  contact,
  contactKey,
  inputValue,
  label,
}) {
  let {
    emails,
    emailsMetadata,
    phones,
    phonesMetadata,
  } = getEditedContactData(contact);

  const emailMetadata = {
    isManuallyAdded: true,
    ...(label ? { label } : {}),
  };
  const phoneMetadata = {
    isManuallyAdded: true,
    ...(label ? { type: label } : {}),
  };
  let itemType;

  switch (contactKey) {
    case ADDABLE_KEYS.email:
      emails = [...emails, inputValue];
      emailsMetadata = [...emailsMetadata, emailMetadata];
      itemType = 'contact_email';

      break;
    case ADDABLE_KEYS.phone:
      phonesMetadata = [...phonesMetadata, phoneMetadata];
      phones = [...phones, inputValue];
      itemType = 'contact_phone';

      break;
    default:
      logger.warn('getContactAddedData called with invalid contactKey', { contactKey });

      return {};
  }

  return {
    phones,
    phonesMetadata,
    emails,
    emailsMetadata,
    itemType,
  };
}
